import { api } from '@services/api'

export const saveViewPages = async (slug: string): Promise<void> => {
  // Não rastreia em desenvolvimento
  if (process.env.NODE_ENV === 'development') {
    return
  }

  try {
    const data = {
      path: slug
    }

    await api.post('/view-pages', data)
  } catch (error) {
    // Silenciosamente ignora erros de view tracking para não quebrar a aplicação
    console.warn('Failed to track page view:', error)
  }
}
